<div *ngIf="isMultiplePropertyFilterVisible">
  <app-multiple-property-filter
    [filterService]="filterService"
    [properties]="multipleProperties"
    [mode]="mode"
    [itemCount] = "itemCount"
    [isCloseButtonVisible]="isCloseButtonVisible"
    (closeRequested)="closeMultiplePropertyFilter()"
    (filterChanged)="emitFilterChanged()">
  </app-multiple-property-filter>
</div>


<div class="sidebar size-S" [ngClass]="{'visible': sidebar.isSideBarVisible('PropertyFilter') }">
  <ng-container *ngIf="sidebar.isSideBarVisible('PropertyFilter')">
    <ng-container [ngSwitch]="currentPropertyFilter.Type">
      <app-string-filter *ngSwitchCase="'string'"
        [property]="currentPropertyFilter"
        [filterMode]="currentPropertyFilterMode"
        [filterService]="filterService"
        [mode]="mode"
        (filterChanged)="emitFilterChanged()">
      </app-string-filter>
      <app-string-filter *ngSwitchCase="'People'"
        [property]="currentPropertyFilter"
        [filterMode]="currentPropertyFilterMode"
        [filterService]="filterService"
        [mode]="mode"
        (filterChanged)="emitFilterChanged()">
      </app-string-filter>
      <app-string-filter *ngSwitchCase="'number'"
        [property]="currentPropertyFilter"
        [filterMode]="currentPropertyFilterMode"
        [filterService]="filterService"
        [mode]="mode"
        (filterChanged)="emitFilterChanged()">
      </app-string-filter>
      <app-date-filter *ngSwitchCase="'Date'"
        [property]="currentPropertyFilter"
        [filterMode]="currentPropertyFilterMode"
        [filterService]="filterService"
        [mode]="mode"
        (filterChanged)="emitFilterChanged()">
      </app-date-filter>
    </ng-container>
  </ng-container>
</div>
